var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4445 17.671V16.5556C17.4445 15.3282 16.4496 14.3333 15.2223 14.3333C13.9949 14.3333 13.0001 15.3282 13.0001 16.5556V17.671M7.4445 21H0.777832C0.777832 16.7044 4.26007 13.2222 8.55561 13.2222C8.93283 13.2222 9.30383 13.2491 9.66672 13.301M13.5556 21H16.8889C17.4066 21 17.6655 21 17.8697 20.9154C18.1419 20.8027 18.3583 20.5863 18.4711 20.3141C18.5556 20.1099 18.5556 19.851 18.5556 19.3333C18.5556 18.8157 18.5556 18.5568 18.4711 18.3526C18.3583 18.0803 18.1419 17.864 17.8697 17.7512C17.6655 17.6667 17.4066 17.6667 16.8889 17.6667H13.5556C13.0379 17.6667 12.7791 17.6667 12.5748 17.7512C12.3026 17.864 12.0863 18.0803 11.9735 18.3526C11.8889 18.5568 11.8889 18.8157 11.8889 19.3333C11.8889 19.851 11.8889 20.1099 11.9735 20.3141C12.0863 20.5863 12.3026 20.8027 12.5748 20.9154C12.7791 21 13.0379 21 13.5556 21ZM13.0001 5.44444C13.0001 7.89904 11.0102 9.88889 8.55561 9.88889C6.10101 9.88889 4.11117 7.89904 4.11117 5.44444C4.11117 2.98984 6.10101 1 8.55561 1C11.0102 1 13.0001 2.98984 13.0001 5.44444Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDashboard);
export default __webpack_public_path__ + "static/media/admin-dashboard.7da6ea7e1f2716d2b4816e20db0da97a.svg";
export { ForwardRef as ReactComponent };